import React, { useState } from 'react';
import AddSingleSubscriptionModal from '../AddSingleSubscriptionModal';
import WithVendorBankingCheck from '../../TransactionsPage/WithVendorBankingCheck';
import { subscriptionPaymentTypesConstants } from '../../../../constants';

const AddSubscriptionWithBankingCheck = ({ modalProps }) => {
  const [paymentType, setPaymentType] = useState(null);

  const checkVendorBankingRequired = ({ vendor, beneficiary }) => {
    return (
      paymentType === subscriptionPaymentTypesConstants.WIRE &&
      vendor &&
      !beneficiary
    );
  };

  return (
    <WithVendorBankingCheck
      checkVendorBankingRequired={checkVendorBankingRequired}
      ModalComponent={AddSingleSubscriptionModal}
      modalProps={{
        ...modalProps,
        onPaymentTypeChange: setPaymentType,
      }}
    />
  );
};

export default AddSubscriptionWithBankingCheck;
